import MasterCrudPage from '../../components/MasterCrudPage';

export default function Nationalities() {
  return (
    <MasterCrudPage
      config={{
        title: 'Nationality',
        apiBase: '/payroll/masters/nationalities',
        listKey: 'nationalities',
        entityKey: 'nationality',
        fields: [{ key: 'ir8aCode', label: 'IR8A Nation Code', type: 'text', maxLength: 10 }],
        bare: true,
      }}
    />
  );
}
